import { Avatar } from '@george-labs.com/design-system';

import type { AddressBook } from './AddressBook';

export const base: AddressBook = {
    trustedContactsAvailable: false,
    contactDetails: {
        icon: Avatar.ICON.USER,
        useDefaultCountry: false,
        fillingBicResetsCountry: true,
        fetchTaxAuthorityName: false,
        fetchAccountName: false,
        fillingIbanResetsCountry: false,
        prefillCorrespondingIban: false,
    },
    abcSelectorButtons: [
        {
            icon: 'star',
            i18Key: 'addressbook:filter.topContacts',
            matches: 'TOP_CONTACTS',
            alwaysEnabled: true,
        },
        {
            key: '123',
            matches: 'OTHER',
        },
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ],
    filters: [
        {
            action: 'CANCEL',
            key: 'ALL',
            modes: [
                'screen',
                'directdebitmodal',
                'newtransfermodal',
                'standingordermodal',
                'purposesavingmodal',
            ],
        },
        {
            action: 'type',
            actionValue: 'CONTACT',
            key: 'CONTACT',
            modes: [
                'screen',
                'directdebitmodal',
                'newtransfermodal',
                'standingordermodal',
                'purposesavingmodal',
            ],
        },
        {
            action: 'ownAccounts',
            actionValue: true,
            key: 'OWN_ACCOUNT',
            modes: [
                'screen',
                'directdebitmodal',
                'newtransfermodal',
                'standingordermodal',
                'purposesavingmodal',
            ],
        },
        {
            action: 'type',
            actionValue: 'TRANSFER',
            key: 'TRANSFER',
            modes: ['screen', 'newtransfermodal', 'standingordermodal'],
        },
        {
            action: 'type',
            actionValue: 'DIRECT_DEBIT',
            key: 'DIRECT_DEBIT',
            modes: ['screen', 'directdebitmodal'],
        },
    ],
    templates: {
        transfer: {
            attributes: [
                'senderName',
                'senderReference',
                'symbols',
                'feeSharingCode',
                'individualConditions',
                'repetitionDays',
                'confirmationEmail',
                'additionalInfo',
                'amount',
            ],
        },
        directDebit: {
            core: ['amount', 'senderName', 'senderReference', 'additionalInfo'],
            nested: ['creditorId', 'mandateId', 'mandateDate', 'sequenceType', 'scheme'],
        },
    },
    prefilling: {
        transfer: [
            'amount',
            'senderName',
            'senderReference',
            'symbols',
            'repetitionDays',
            'additionalInfo',
        ],
        'direct-debit': [
            'amount',
            'senderName',
            'senderReference',
            'symbols',
            'additionalInfo',
            'mandateDate',
            'mandateId',
            'scheme',
            'sequenceType',
        ],
    },
    addressBookItem: {
        displayAccountNoForTemplate: false,
        displayTemplateType: true,
    },
    shouldPreferBankCodeInput: false,
    cacheDuration: {
        contact: 0,
        template: 0,
        templates: 0,
        search: 0,
    },
    cacheDurationV2: {
        entity: 300_000,
        search: 0,
    },
};
